import { ServiceType } from "@agroyaar/sdk";
// @ts-ignore
import whiteLogo from "../../../../../../public/assets/icons/logowhite.svg";
import { reportBackgroundColor } from "../../../utils/report-color";

interface HeaderIntroductionProps {
  serviceType: ServiceType;
}

const HeaderIntroduction = ({ serviceType }: HeaderIntroductionProps) => {
  const reportBackground = reportBackgroundColor(serviceType);

  return (
    <div className="flex flex-col items-center gap-[8rem] w-full h-[100px]">
      <div className="relative w-full flex bg-white">
        <span
          className="absolute top-0 left-0 w-full h-[100px] rounded-br-[1300px]"
          style={{ background: reportBackground }}
        />
        <span
          className="absolute top-0 left-0 w-full h-[90px] rounded-br-[1300px] blur-[2px]"
          style={{ background: reportBackground }}
        />
        <div className="absolute top-[5px] left-0 flex items-center gap-[12px] pl-[12px]">
          <div className="flex flex-col my-4 gap-[8px] font-IRANSansX">
            <span className="text-white font-extrabold text-[20px]">
              اگـــــــــرویـــــار
            </span>
            <span className="text-white font-extrabold text-[9px]">
              پلتفرم جامع خدمات کشاورزی
            </span>
          </div>
          <img src={whiteLogo} alt="logo" className="h-[50px]" />
        </div>
      </div>
    </div>
  );
};

export default HeaderIntroduction;
